// Define functions OUTSIDE DOMContentLoaded so they're accessible everywhere
function attachCartListeners(){
   const plusBtns = document.querySelectorAll(".cart_item .quantity_button[name='plus']")
   const minusBtns = document.querySelectorAll(".cart_item .quantity_button[name='minus']")
   const removeBtns = document.querySelectorAll(".cart_item .remove-product")


   plusBtns.forEach(btn=>{
      btn.addEventListener("click",()=>{
         handleIncrement(btn)
      })
   })

   minusBtns.forEach(btn=>{
      btn.addEventListener("click",()=>{
         handleDecrement(btn)
      })
   })

      removeBtns.forEach(btn=>{
      btn.addEventListener("click",()=>{
         console.log("clicked")
         handleDelete(btn)
      })
   })
}

//


// Disable all the buttons till api calls
function disableAllCartButtons() {
   const allBtns = document.querySelectorAll(".cart_item .quantity_button");
   allBtns.forEach(btn => {
      btn.disabled = true;
      btn.style.cursor = 'not-allowed';
      btn.style.opacity = '0.5';
   });
}

function enableAllCartButtons() {
   const allBtns = document.querySelectorAll(".cart_item .quantity_button");
   allBtns.forEach(btn => {
      btn.disabled = false;
      btn.style.cursor = 'pointer';
      btn.style.opacity = '1';
   });
}

function handleIncrement(button){
   const line = button.dataset.line;
   const key = button.dataset.key;
   const currentQty = parseInt(button.dataset.quantity);
   const newQty = currentQty + 1;
   
   updateCartItem(line, newQty);
}

function handleDecrement(button){
   const line = button.dataset.line;
   const currentQty = parseInt(button.dataset.quantity);
   const newQty = Math.max(0, currentQty - 1);
   
   updateCartItem(line, newQty);
}

function handleDelete(button){
   const line = button.dataset.line;
   // Set quantity to 0 to remove item
   updateCartItem(line, 0);
}

function updateCartItem(line, quantity) {
   // Disable buttons before API call
   disableAllCartButtons();

   fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line, quantity })
   })
   .then(res => res.json())
   .then(cart => {
      console.log('Cart updated:', cart);
      refreshCartSection();
   })
   .catch(err => {
      console.error('Update failed:', err)
    // Re-enable buttons if there's an error
      enableAllCartButtons();
   });
}

function refreshCartSection() {
   disableAllCartButtons();

   fetch(`${window.location.pathname}?section_id=side-cart`)
      .then(res => res.text())
      .then(html => {
         const parser = new DOMParser();
         const doc = parser.parseFromString(html, 'text/html');
         
         // 1. Grab fresh body and footer wrappers from fetched html
         const newCartWrapper = doc.querySelector('#cart-wrapper');
         const newFooterWrapper = doc.querySelector('#cart-footer-wrapper');
         
         // 2. Update the scrolling body content
         if (newCartWrapper) {
            document.querySelector('#cart-wrapper').innerHTML = newCartWrapper.innerHTML;
         }

         // 3. Update the sticky footer content (will clear out completely if cart == empty)
         if (newFooterWrapper) {
            document.querySelector('#cart-footer-wrapper').innerHTML = newFooterWrapper.innerHTML;
         }
         
         console.log('Cart refreshed smoothly.');
         attachCartListeners();  
      })
      .catch(err => {
         console.error('Refresh failed:', err);
         enableAllCartButtons();
      });
}

   window.refreshCartSection = refreshCartSection;

// Refresh the cart on clicking add-to-cart btn on product page
function refreshOnAddBtnClick(){
   const addbtns = document.querySelectorAll(".product-form__submit.button");
   addbtns.forEach((btn)=>{
      btn.addEventListener("click",()=>{
         setTimeout(() => {
            refreshCartSection();
         }, 1000); 
      })
   })
}

window.addEventListener("DOMContentLoaded", () => {
   attachCartListeners();
   refreshOnAddBtnClick();
});

// Also handle Shopify section updates
document.addEventListener('shopify:section:load', function(event) {
   if (event.detail.sectionId.includes('cart')) {
      attachCartListeners();
   }
});


const toggleCartDrawer = () => {
  const drawer = document.getElementById('custom-cart-drawer');
  if (!drawer) return console.error('Cart drawer element not found');

  const isHidden = drawer.classList.contains('hidden');

  if (isHidden) {
    // Call only when opening
   if (typeof window.refreshCartSection === 'function') {
    window.refreshCartSection();
  }

    drawer.classList.remove('hidden');
    setTimeout(() => drawer.classList.add('active'), 10);
    document.body.style.overflow = 'hidden';
  } else {
    drawer.classList.remove('active');
    setTimeout(() => drawer.classList.add('hidden'), 300);
    document.body.style.overflow = '';
  }
};

// Toggle drawer when product is added to the cart
document.addEventListener('productAddedToCart', (event) => {
    toggleCartDrawer();
});